export enum SelectMode {
    Range = 'range',
    Day = 'day',
    Month = 'month'
}
